import styled from "@emotion/styled/macro";
import isStyledPropsValid from "utils/isStyledPropsValid";
import Box from "@mui/material/Box";

export const StyledLeftFieldContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, sx }) => ({
  marginBottom: "16px",
  "&:last-child": {
    marginBottom: 0,
  },
  ...sx,
}));

export const StyledLabel = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, sx }) => ({
  color: "#555",
  fontSize: "14px",
  fontWeight: "500",
  lineHeight: "20px",
  marginBottom: "4px",
  ...sx,
}));

export const StyledImportCard = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, sx }) => ({
  backgroundColor: "#FFF",
  padding: "24px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  borderRadius: "4px",
  ...sx,
}));

export const StyledImportIcon = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, sx }) => ({
  height: "59px",
  width: "59px",
  borderRadius: "50%",
  backgroundColor: "#FAF6FF",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  ...sx,
}));

export const StyledCountText = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, sx }) => ({
  color: "#7B61FF",
  fontWeight: 500,
  display: "inline",
  marginRight: "4px",
}));

export const StyledSearchBar = styled.div`
  position: absolute;
  top: 38px;
  left: 0px;
  width: 296px;
  padding: 12px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  cursor: pointer;
  z-index: 100;
  &:hover {
    background-color: #f7f1fe;
  }
`;
